/**
 * MSH mobile hamburger drawer additions.
 *
 * Two independent enhancements, both scoped to markup added in
 * snippets/header-drawer.liquid (mobile-drawer variant only):
 *
 * 1. Featured Products carousel prev/next arrows — same seamless-loop
 *    technique as sections/msh-featured-products.liquid (3 duplicated sets,
 *    requestAnimationFrame-driven smooth scroll, wrap-around correction at
 *    each end). Card widths are fixed px (set in header-drawer.liquid's
 *    stylesheet), not percentage-based, which avoids the circular sizing
 *    bug a percentage width causes inside a duplicated-set wrapper.
 *
 * 2. Accordion auto-scroll-into-view — when a top-level drawer accordion row
 *    (Boots / Sneakers / Casuals / Interest, etc.) is opened, its newly
 *    revealed sub-items are scrolled into view so they're never hidden
 *    below the fold. Hooks the native <details> "toggle" event on the
 *    theme's own accordion-custom element rather than bypassing it.
 */
(function () {
  function initFeaturedCarousel(root) {
    var row = root.querySelector('[data-msh-drawer-featured-row]');
    var setMid = root.querySelector('[data-msh-drawer-featured-set-mid]');
    var prev = root.querySelector('[data-msh-drawer-featured-prev]');
    var next = root.querySelector('[data-msh-drawer-featured-next]');
    if (!row || !setMid || !prev || !next) return;
    if (row.dataset.mshInitialized === 'true') return;
    row.dataset.mshInitialized = 'true';

    // Measured once at init: all three duplicated sets are identical width,
    // so this value is stable and only used for the initial scroll position
    // and the wrap-around boundary check.
    var setWidth = setMid.getBoundingClientRect().width + 12; // + gap between sets

    row.scrollLeft = setWidth; // start on the middle (real) set, room to go either way

    // Measured fresh on every click, never cached — caching at load time can
    // read a near-zero width before layout has settled.
    function getCardPitch() {
      var card = setMid.querySelector('.msh-drawer-fcard');
      return card ? card.getBoundingClientRect().width + 12 : 0;
    }

    var animating = false;
    function animateBy(delta) {
      if (animating || !delta) return;
      animating = true;
      var start = row.scrollLeft;
      var target = start + delta;
      var duration = 380;
      var startTime = null;
      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }
      function step(timestamp) {
        if (startTime === null) startTime = timestamp;
        var elapsed = timestamp - startTime;
        var progress = Math.min(elapsed / duration, 1);
        row.scrollLeft = start + (target - start) * easeOutCubic(progress);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          if (row.scrollLeft >= setWidth * 2) {
            row.scrollLeft -= setWidth;
          } else if (row.scrollLeft <= 0) {
            row.scrollLeft += setWidth;
          }
          animating = false;
        }
      }
      window.requestAnimationFrame(step);
    }

    next.addEventListener('click', function () {
      animateBy(getCardPitch());
    });
    prev.addEventListener('click', function () {
      animateBy(-getCardPitch());
    });
  }

  function initAccordionAutoScroll(root) {
    var items = root.querySelectorAll('.menu-drawer__list-item--deep > accordion-custom > details');
    items.forEach(function (details) {
      if (details.dataset.mshScrollBound === 'true') return;
      details.dataset.mshScrollBound = 'true';

      details.addEventListener('toggle', function () {
        if (!details.open) return;
        var item = details.closest('.menu-drawer__list-item--deep');
        if (!item) return;
        // Wait for the accordion's max-height/block-size transition to
        // finish opening before scrolling, so the target height is settled
        // (matches the ~260ms used in the mobile-nav-mockup.html prototype).
        window.setTimeout(function () {
          item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 260);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.msh-drawer-featured').forEach(initFeaturedCarousel);
    document.querySelectorAll('.menu-drawer').forEach(initAccordionAutoScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // The drawer's contents can be re-hydrated by the Section Rendering API
  // (e.g. after a customizer edit) without a full page reload, so re-run
  // init on that event too — same safeguard used by other header components.
  document.addEventListener('shopify:section:load', initAll);
})();
